import { HttpErrorResponse } from "@angular/common/http";
import { ErrorResponseModel } from "../../shared/local-api.types";
import { isObjectWithProperties } from "../utils/object.utils";

export function isHttpError(error: unknown): error is HttpErrorResponse {
  return !!error && typeof error === "object" && "error" in error;
}

export function isKnownApiError(error: unknown): error is ErrorResponseModel {
  return (
    isObjectWithProperties(error, "errorCode") &&
    typeof error.errorCode === "string" &&
    isObjectWithProperties(error, "errorMessage") &&
    typeof error.errorMessage === "string"
  );
}

export const fallbackApiErrorMessage = "Something went wrong, please try again";

export function toApiErrorMessage(error: unknown): string {
  if (isKnownApiError(error)) {
    return error.errorMessage;
  }

  if (isObjectWithProperties(error, "message")) {
    if (Array.isArray(error.message) && error.message.length > 0) {
      return error.message.join(", ");
    }
    if (typeof error.message === "string" && error.message.length > 0) {
      return error.message;
    }
  }

  return fallbackApiErrorMessage;
}
